/**
 * Generates a non-PII browser fingerprint hash for device tracking.
 * Uses: User-Agent + screen resolution + timezone + language + color depth
 */
export function getDeviceFingerprint(): { hash: string; label: string } {
  const ua = navigator.userAgent;

  const components = [
    ua,
    `${screen.width}x${screen.height}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.language,
    `${screen.colorDepth}bit`,
    navigator.hardwareConcurrency?.toString() || '',
    navigator.platform || '',
  ];

  const raw = components.join('|');
  let hash = 0;
  for (let i = 0; i < raw.length; i++) {
    const char = raw.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  const fingerprint = Math.abs(hash).toString(36);

  // Generate human-readable device label
  let browser = 'Unknown';
  let os = 'Unknown';

  if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('OPR/') || ua.includes('Opera')) browser = 'Opera';
  else if (ua.includes('Chrome/') && !ua.includes('Edg/')) browser = 'Chrome';
  else if (ua.includes('Safari/') && !ua.includes('Chrome')) browser = 'Safari';
  else if (ua.includes('Firefox/')) browser = 'Firefox';

  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS X') || ua.includes('Macintosh')) os = 'macOS';
  else if (ua.includes('Linux') && !ua.includes('Android')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';

  return {
    hash: fingerprint,
    label: `${browser} on ${os}`,
  };
}
